import React, { useState, useEffect } from 'react';
import Fnc from '../library/Functions'
import InlineFieldLoader from './InlineFieldLoader';

function SdiInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [sdiVerified, setSdiVerified] = useState(false);

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:

  }, []); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;

    if (val && val.length > 0) {
      //non ho un valore vuoto

      if (sdiVerified !== val) {
        //non è un valore che ho già controllato

        setLoading(true);

        let valdSdi = Fnc.validateSdi(val);
        if (valdSdi === Fnc.EnmSdi.OK) {
          //sdi formalmente valida?
          props.callback(new Fnc.Ret(Fnc.EnmSdi.OK,val));
          setShowError(false);
          setErrorMsg(null);

        } else {
          setSdiVerified(null);
          setShowError(true);
          setErrorMsg(valdSdi.msg);
          props.callback(new Fnc.Ret(valdSdi));
        }

        setLoading(false);

      }

    } else {
      //setShowError(true);
      //setErrorMsg(Fnc.RetGen.EMPTY.msg);
      setShowError(false);
      setErrorMsg(null);
      props.callback(new Fnc.Ret(Fnc.EnmSdi.EMPTY));
    }

  }


  return (
    <>
      <input className={`form-control ${showError ? "iol-field--error" : ""}`} type="text" id="sdipec" placeholder="Es. ABC1234" key={props.sdi} defaultValue={props.sdi} onBlur={onBlur} aria-invalid={showError}></input>
      <span className={`placeholder-text ${showError && "lblError"} `}>SDI</span>
      <InlineFieldLoader visible={loading} label="Verifica SDI in corso" />
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default SdiInp;
